export const orgTypes = [
  {
    id: 0,
    value: 'OWNER',
  },
  {
    id: 1,
    value: 'CUSTOMER',
  },
  {
    id: 2,
    value: 'MANUFACTURER',
  },
  {
    id: 3,
    value: 'DEVICE MANAGER',
  },
  {
    id: 4,
    value: 'MAINTENANCE',
  },
];

export const roles = [
  {
    id: '0',
    value: 'Admin',
  },
  {
    id: '1',
    value: 'Editor',
  },
  {
    id: '2',
    value: 'Editor - (Leader)',
  },
  {
    id: '3',
    value: 'Viewer',
  },
];

export const newRoles = [
  {
    id: '0',
    value: 'Admin',
  },
  {
    id: '1',
    value: 'Editor',
  },
  {
    id: '3',
    value: 'Viewer',
  },
];
